var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-4 pa-4"
  }, [!_vm.isView ? _c('div', {
    staticClass: "alert-message d-flex align-center"
  }, [_c('v-icon', {
    staticClass: "mr-2",
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert-circle")]), _c('span', [_vm._v("Os campos marcados com asterisco(*) são obrigatórios")])], 1) : _vm._e(), _c('v-toolbar', {
    staticClass: "mt-4",
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-pencil")]), _vm._v(" Acompanhamento da Turma " + _vm._s(_vm.isView ? '- Visualizar' : '') + " "), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mt-3"
  }, _vm._l(_vm.camposFixos, function (campo, i) {
    return _c('v-col', {
      key: i,
      attrs: {
        "cols": "6"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": campo.label,
        "value": campo.valor,
        "disabled": "",
        "outlined": "",
        "dense": ""
      }
    })], 1);
  }), 1), _c('v-tabs', {
    attrs: {
      "value": _vm.bimestreSelecionado
    }
  }, _vm._l(_vm.bimestres, function (b, i) {
    return _c('v-tab', {
      key: i,
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.handleTabClick(i);
        }
      }
    }, [_vm._v(_vm._s(b.nome))]);
  }), 1), _c('v-tabs-items', {
    model: {
      value: _vm.bimestreSelecionado,
      callback: function ($$v) {
        _vm.bimestreSelecionado = $$v;
      },
      expression: "bimestreSelecionado"
    }
  }, _vm._l(_vm.bimestres, function (b, i) {
    return _c('v-tab-item', {
      key: i
    }, [_c('v-expansion-panels', {
      attrs: {
        "multiple": ""
      },
      model: {
        value: _vm.painelAtivo[i],
        callback: function ($$v) {
          _vm.$set(_vm.painelAtivo, i, $$v);
        },
        expression: "painelAtivo[i]"
      }
    }, _vm._l(b.grupos, function (grupo, gIndex) {
      return _c('v-expansion-panel', {
        key: gIndex,
        staticClass: "mb-4"
      }, [_c('v-expansion-panel-header', {
        staticClass: "font-weight-bold text-subtitle-1",
        class: {
          'red--text': grupo.itens.some(function (i) {
            return i.erro;
          })
        }
      }, [_c('h3', {
        staticClass: "mb-0",
        staticStyle: {
          "justify-content": "center",
          "text-align": "center"
        }
      }, [_vm._v(" " + _vm._s(grupo.nome) + " "), grupo.itens.some(function (i) {
        return i.erro;
      }) ? _c('v-icon', {
        staticClass: "mr-2",
        attrs: {
          "color": "red"
        }
      }, [_vm._v("mdi-alert-circle")]) : _vm._e()], 1)]), _c('v-expansion-panel-content', {
        ref: `grupo-panel-${i}-${gIndex}`,
        refInFor: true,
        staticClass: "pa-4",
        attrs: {
          "eager": ""
        }
      }, [grupo.isPraticaLinguagem && !_vm.isView ? _c('div', {
        staticClass: "d-flex justify-end mb-4"
      }, [_c('v-tooltip', {
        attrs: {
          "top": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function (_ref) {
            var on = _ref.on,
              attrs = _ref.attrs;
            return [_c('v-btn', _vm._g(_vm._b({
              attrs: {
                "icon": "",
                "small": "",
                "color": "primary"
              },
              on: {
                "click": function ($event) {
                  return _vm.abrirDialogo(grupo, 2);
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
          }
        }], null, true)
      }, [_c('span', [_vm._v("Incluir Práticas de Linguagem")])])], 1) : _vm._e(), grupo.isUnidadeTematica && !_vm.isView ? _c('div', {
        staticClass: "d-flex justify-end mb-4"
      }, [_c('v-tooltip', {
        attrs: {
          "top": ""
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function (_ref2) {
            var on = _ref2.on,
              attrs = _ref2.attrs;
            return [_c('v-btn', _vm._g(_vm._b({
              attrs: {
                "icon": "",
                "small": "",
                "color": "primary"
              },
              on: {
                "click": function ($event) {
                  return _vm.abrirDialogo(grupo, 1);
                }
              }
            }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
          }
        }], null, true)
      }, [_c('span', [_vm._v("Incluir Unidade Temática")])])], 1) : _vm._e(), grupo.cabecalhos ? _c('v-row', {
        staticClass: "font-weight-bold text--darken-2 mb-2"
      }, _vm._l(grupo.cabecalhos, function (cab, hIndex) {
        return _c('v-col', {
          key: hIndex,
          attrs: {
            "cols": cab.cols || 4
          }
        }, [_vm._v(" " + _vm._s(cab.label) + " ")]);
      }), 1) : _vm._e(), _vm._l(grupo.itens, function (item, idx) {
        var _grupo$cabecalhos, _grupo$cabecalhos$, _grupo$cabecalhos2, _grupo$cabecalhos2$, _grupo$cabecalhos3, _grupo$cabecalhos3$;
        return _c('div', {
          key: idx,
          staticStyle: {
            "border-bottom": "1px solid #e0e0e0",
            "padding": "12px 0"
          }
        }, [_c('v-row', [grupo.isPraticaLinguagem || grupo.isUnidadeTematica ? [_c('v-col', {
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.pratica))]), _c('v-col', {
          attrs: {
            "cols": "2"
          }
        }, [_vm._v(_vm._s(item.codigo))]), _c('v-col', {
          attrs: {
            "cols": "1.5"
          }
        }, [_c('v-text-field', {
          ref: `input-${i}-${gIndex}-${idx}-nao`,
          refInFor: true,
          staticClass: "no-spin",
          attrs: {
            "type": "number",
            "outlined": "",
            "dense": "",
            "disabled": _vm.isView,
            "rules": [function (v) {
              return v === 0 || !!v || 'Campo obrigatório';
            }]
          },
          on: {
            "input": function ($event) {
              return _vm.validarTotais(grupo);
            }
          },
          model: {
            value: item.qtdNao,
            callback: function ($$v) {
              _vm.$set(item, "qtdNao", _vm._n($$v));
            },
            expression: "item.qtdNao"
          }
        })], 1), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "1.5"
          }
        }, [_vm._v(_vm._s(item.percNao) + "%")]), _c('v-col', {
          attrs: {
            "cols": "1.5"
          }
        }, [_c('v-text-field', {
          staticClass: "no-spin",
          attrs: {
            "type": "number",
            "outlined": "",
            "dense": "",
            "disabled": _vm.isView,
            "rules": [function (v) {
              return v === 0 || !!v || 'Campo obrigatório';
            }]
          },
          on: {
            "input": function ($event) {
              return _vm.validarTotais(grupo);
            }
          },
          model: {
            value: item.qtdParcial,
            callback: function ($$v) {
              _vm.$set(item, "qtdParcial", _vm._n($$v));
            },
            expression: "item.qtdParcial"
          }
        })], 1), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "1.5"
          }
        }, [_vm._v(_vm._s(item.percParcial) + "%")]), _c('v-col', {
          attrs: {
            "cols": "1.5"
          }
        }, [_c('v-text-field', {
          staticClass: "no-spin",
          attrs: {
            "type": "number",
            "outlined": "",
            "dense": "",
            "disabled": _vm.isView,
            "rules": [function (v) {
              return v === 0 || !!v || 'Campo obrigatório';
            }]
          },
          on: {
            "input": function ($event) {
              return _vm.validarTotais(grupo);
            }
          },
          model: {
            value: item.qtdTotal,
            callback: function ($$v) {
              _vm.$set(item, "qtdTotal", _vm._n($$v));
            },
            expression: "item.qtdTotal"
          }
        })], 1), _c('v-col', {
          staticClass: "text-center",
          attrs: {
            "cols": "1.5"
          }
        }, [_vm._v(_vm._s(item.percTotal) + "%")])] : [_c('v-col', {
          attrs: {
            "cols": ((_grupo$cabecalhos = grupo.cabecalhos) === null || _grupo$cabecalhos === void 0 ? void 0 : (_grupo$cabecalhos$ = _grupo$cabecalhos[0]) === null || _grupo$cabecalhos$ === void 0 ? void 0 : _grupo$cabecalhos$.cols) || 4
          }
        }, [_vm._v(_vm._s(item.descricao))]), _c('v-col', {
          attrs: {
            "cols": ((_grupo$cabecalhos2 = grupo.cabecalhos) === null || _grupo$cabecalhos2 === void 0 ? void 0 : (_grupo$cabecalhos2$ = _grupo$cabecalhos2[2]) === null || _grupo$cabecalhos2$ === void 0 ? void 0 : _grupo$cabecalhos2$.cols) || 4
          }
        }, [_c('v-text-field', {
          ref: `input-${i}-${gIndex}-${idx}`,
          refInFor: true,
          staticClass: "no-spin",
          class: {
            'erro-campo': item.erro
          },
          attrs: {
            "type": "number",
            "outlined": "",
            "dense": "",
            "disabled": _vm.isView,
            "rules": [function (v) {
              return v === 0 || !!v || 'Campo obrigatório';
            }]
          },
          on: {
            "input": function ($event) {
              return _vm.onIntegerInput(item, 'qtd', grupo);
            }
          },
          model: {
            value: item.qtd,
            callback: function ($$v) {
              _vm.$set(item, "qtd", _vm._n($$v));
            },
            expression: "item.qtd"
          }
        })], 1), _c('v-col', {
          attrs: {
            "cols": ((_grupo$cabecalhos3 = grupo.cabecalhos) === null || _grupo$cabecalhos3 === void 0 ? void 0 : (_grupo$cabecalhos3$ = _grupo$cabecalhos3[2]) === null || _grupo$cabecalhos3$ === void 0 ? void 0 : _grupo$cabecalhos3$.cols) || 4
          }
        }, [_c('div', {
          staticClass: "text-subtitle-2 text-right pr-2 text-center"
        }, [_vm._v(_vm._s(item.percentual) + "%")])])]], 2)], 1);
      })], 2)], 1);
    }), 1)], 1);
  }), 1), !_vm.isView ? _c('div', {
    staticClass: "d-flex justify-end mt-4"
  }, [_c('sca-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.salvar();
      },
      "cancel": function ($event) {
        return _vm.voltar();
      }
    }
  })], 1) : _c('div', {
    staticClass: "btn-group text-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.voltar
    }
  }, [_c('v-icon', [_vm._v("mdi-close")]), _vm._v(" Fechar ")], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "max-width": "500"
    },
    model: {
      value: _vm.mostrarDialogo,
      callback: function ($$v) {
        _vm.mostrarDialogo = $$v;
      },
      expression: "mostrarDialogo"
    }
  }, [_c('v-card', {
    staticClass: "not-margin pt-0 pr-0 pl-0"
  }, [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "color": "primary"
    }
  }, [_c('div', {
    staticClass: "text-center"
  }, [_vm._v(" " + _vm._s(_vm.tipoSelecionado === 2 ? "Práticas de Linguagem" : "Unidade Temática") + " ")])]), _c('v-card-text', {
    staticClass: "pt-0 mt-6"
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.praticasDisponiveis,
      "item-text": "descricao",
      "item-value": "praticaId",
      "label": _vm.tipoSelecionado === 2 ? 'Prática de Linguagem' : 'Unidade Temática',
      "outlined": "",
      "dense": "",
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    on: {
      "change": _vm.carregarCodigos
    },
    model: {
      value: _vm.praticaSelecionada,
      callback: function ($$v) {
        _vm.praticaSelecionada = $$v;
      },
      expression: "praticaSelecionada"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "items": _vm.codigosDisponiveis,
      "item-text": "codigoHabilidade",
      "item-value": "habilidadeId",
      "label": "Código da Habilidade",
      "outlined": "",
      "dense": "",
      "disabled": !_vm.praticaSelecionada,
      "rules": [function (v) {
        return !!v || 'Campo obrigatório';
      }]
    },
    model: {
      value: _vm.codigoSelecionado,
      callback: function ($$v) {
        _vm.codigoSelecionado = $$v;
      },
      expression: "codigoSelecionado"
    }
  })], 1), _c('div', {
    staticClass: "d-flex justify-end mt-4"
  }, [_c('sca-buttons', {
    attrs: {
      "actionText": 'Salvar'
    },
    on: {
      "click": function ($event) {
        return _vm.confirmarInclusao();
      },
      "cancel": function ($event) {
        _vm.mostrarDialogo = false;
      }
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }